import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet } from 'react-router-dom';

import { Header } from '../../components/layout/Header';
import { Sidebar } from '../../components/layout/Sidebar';
import { useAuth } from '../../providers/AuthProvider';

/**
 * Main application layout component that combines:
 * - Base layout container
 * - App header
 * - Sidebar for authenticated routes
 * - Main content area with Outlet
 */
export function AppLayout() {
  const [navbarOpened, { toggle: toggleNavbar, close: closeNavbar }] = useDisclosure(false);
  const { isAuthenticated } = useAuth();

  return (
    <AppShell
      header={{ height: 73 }}
      navbar={{
        width: 250,
        breakpoint: 'md',
        collapsed: { desktop: !isAuthenticated, mobile: !isAuthenticated || !navbarOpened },
      }}
      padding={0}
      bg="light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-7))"
    >
      <AppShell.Header>
        <Header
          isAuthenticated={isAuthenticated}
          showBurger={isAuthenticated}
          onBurgerClick={isAuthenticated ? toggleNavbar : undefined}
        />
      </AppShell.Header>

      {isAuthenticated && (
        <AppShell.Navbar p="md">
          <Sidebar onNavItemClick={closeNavbar} />
        </AppShell.Navbar>
      )}

      <AppShell.Main display="flex" style={{ flexDirection: 'column' }}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
